import * as React from "react";
import { Alert, Button, Card, Form } from "react-bootstrap";
import styled from "styled-components";

const Direction = styled.p`
	white-space: pre-wrap;
`;

export type MFAVerificationChallengePageProps = {
	email: string;
	error?: string;
	isPending: boolean;
	onSubmit: (code: string) => Promise<void>;
};

/**
 * メール認証
 * - MFAセットアップの前に、登録メールアドレスに送信した認証コードで本人確認する
 */
export const MFAVerificationChallengePage = React.memo((props: MFAVerificationChallengePageProps) => {
	const { email, error, isPending, onSubmit } = props;
	const [code, setCode] = React.useState<string>("");

	const onChangeCode = React.useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => setCode(event.target.value.trim()),
		[],
	);

	const isDisabled = isPending || code.length !== 6;

	/**
	 * Enterキー押下時のブラウザ標準のフォーム送信（ページ遷移）を抑止する
	 */
	const onFormSubmit = React.useCallback(
		(event: React.FormEvent) => {
			event.preventDefault();
			if (isDisabled) return;
			onSubmit(code).catch(() => setCode(""));
		},
		[code, isDisabled, onSubmit],
	);

	return (
		<Card className="border-0 mx-auto my-5" style={{ maxWidth: "540px" }}>
			<Card.Body>
				{error && <Alert variant={"danger"}>{error}</Alert>}
				<Direction>
					{`登録されているメールアドレス(${email})に本人確認のための認証コードを送信しました。\nメールに記載された認証コードを入力してください。`}
				</Direction>
				<Form noValidate onSubmit={onFormSubmit}>
					<Form.Group>
						<Form.Label>認証コード</Form.Label>
						<Form.Control
							autoComplete="one-time-code"
							autoFocus
							inputMode="numeric"
							isInvalid={!!error}
							maxLength={6}
							onChange={onChangeCode}
							placeholder="認証コード(6桁)"
							value={code}
						/>
					</Form.Group>
					<div className="my-4">
						<Button className="w-100" variant={"dark"} type="submit" disabled={isDisabled}>
							承認
						</Button>
					</div>
				</Form>
			</Card.Body>
		</Card>
	);
});
